module.exports = __webpack_public_path__ + "img/cana.f387c676.svg";